
// PRE_REGISTRATION_CONFIGURATIONs
export const GET_PRE_REGISTRATION_CONFIGURATIONS = "/pre-registration-configurations";
export const ADD_NEW_PRE_REGISTRATION_CONFIGURATION = "/pre-registration-configurations";
export const UPDATE_PRE_REGISTRATION_CONFIGURATION = "/pre-registration-configurations";
export const DELETE_PRE_REGISTRATION_CONFIGURATION = "/pre-registration-configurations";


